var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20795 2.16663H10.7919C12.9318 2.16663 14.6666 3.94073 14.6666 6.12912V6.62276L14.6667 6.63496L14.6666 6.64716V10.1789L14.6667 10.1911L14.6666 10.2033V10.8708C14.6666 13.0592 12.9318 14.8333 10.7919 14.8333H5.20795C3.06804 14.8333 1.33325 13.0592 1.33325 10.8708V6.12912C1.33325 3.94073 3.06804 2.16663 5.20795 2.16663ZM13.6975 6.12918V6.13945H11.5669L11.4448 6.14289C10.2734 6.20831 9.3431 7.19944 9.3431 8.41301C9.34385 9.66873 10.3388 10.6858 11.5666 10.6866H13.6975V10.8709C13.6975 12.5119 12.3966 13.8423 10.7919 13.8423H5.20793C3.60322 13.8423 2.30229 12.5119 2.30229 10.8709V6.12918C2.30229 4.48811 3.60322 3.1577 5.20793 3.1577H10.7919C12.3966 3.1577 13.6975 4.48811 13.6975 6.12918ZM13.6975 7.13046V9.69556H11.5669L11.4688 9.69164C10.8219 9.64016 10.3126 9.08743 10.3121 8.41271C10.3121 7.70497 10.8739 7.1309 11.5672 7.13046H13.6975ZM12.3472 8.37233C12.3472 8.09867 12.1303 7.87682 11.8627 7.87682H11.6613L11.5956 7.88135C11.3591 7.91416 11.1768 8.12147 11.1768 8.37233C11.1768 8.64599 11.3937 8.86783 11.6613 8.86783H11.8627L11.9284 8.86331C12.1649 8.8305 12.3472 8.62318 12.3472 8.37233ZM8.72036 5.66031C8.72036 5.38665 8.50343 5.1648 8.23583 5.1648H4.74793L4.68218 5.16933C4.44568 5.20214 4.2634 5.40945 4.2634 5.66031C4.2634 5.93397 4.48033 6.15581 4.74793 6.15581H8.23583L8.30158 6.15129C8.53808 6.11848 8.72036 5.91116 8.72036 5.66031Z",
    fill: "white",
    fillOpacity: 0.73
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.7c1838c4.svg";
export { ForwardRef as ReactComponent };